import {
  Card,
  Input,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Text,
  Title,
} from "@assetwatch/ui";
import type { Profile } from "../../types/profile";

function initials(profile: Profile) {
  return `${profile.firstName.at(0) ?? ""}${profile.lastName.at(0) ?? ""}`;
}

export function ProfileForm({ profile }: { profile: Profile }) {
  return (
    <Tabs defaultValue="general">
      <TabsList aria-label="Profile settings">
        <TabsTrigger value="general">General</TabsTrigger>
        <TabsTrigger value="display" disabled>
          Display Preferences
        </TabsTrigger>
        <TabsTrigger value="notifications" disabled>
          Notifications
        </TabsTrigger>
      </TabsList>
      <TabsContent value="general">
        <Card padding="none">
          <div className="w-full border-b border-outline-variant bg-surface-container-low px-(--spacing-16) py-(--spacing-12)">
            <Text>Personal Information</Text>
          </div>
          <div className="flex w-full flex-col gap-(--spacing-20) p-(--spacing-20)">
            <div className="grid grid-cols-1 gap-(--spacing-32) md:grid-cols-[96px_minmax(0,1fr)]">
              <div
                aria-label={`${profile.firstName} ${profile.lastName}`}
                className="flex size-[96px] items-center justify-center rounded-(--radius-sm) bg-surface-container-highest text-text-subtle"
                role="img"
              >
                <Title size="xl" weight="semibold">
                  {initials(profile)}
                </Title>
              </div>
              <div className="grid min-w-0 grid-cols-1 gap-(--spacing-16) md:grid-cols-2">
                <Input label="First Name" readOnly value={profile.firstName} />
                <Input label="Last Name" readOnly value={profile.lastName} />
                <div className="md:col-span-2">
                  <Input
                    label="Email"
                    readOnly
                    type="email"
                    value={profile.email}
                  />
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-(--spacing-16) md:grid-cols-[160px_minmax(0,1fr)]">
              <Input
                label="Phone Country Code"
                readOnly
                value={profile.phoneCountryCode}
              />
              <Input label="Phone" readOnly type="tel" value={profile.phone} />
            </div>
            <Input label="Country" readOnly value={profile.country} />
            <Input label="Time Zone" readOnly value={profile.timezone} />
            <Input label="Language" readOnly value={profile.language} />
          </div>
        </Card>
      </TabsContent>
    </Tabs>
  );
}
